module.exports = __webpack_public_path__ + "img/pic3.e3764270.png";